// extracted by mini-css-extract-plugin
export default {"nav":"Teams_nav__1mm8B","rightNav":"Teams_rightNav__3t7eA","filter":"Teams_filter__RId16","content":"Teams_content__f4dei","empty":"Teams_empty__2odjF"};